import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { canUseOrders } from "../../../helpers/orderEnabled";
import { readAuthUser } from "../../../helpers/studioModules";
import { ParcelsCard, canUseParcels, useParcelsWithoutMemo } from "./ParcelsCard";
import "./salesPhone.scss";

/** Parcels tracked without a memo: a sample, a repair, or one billed straight in Zoho. Phone, tablet and laptop. */
const SalesParcelsPage = () => {
  const history = useHistory();
  const role: string | undefined = readAuthUser()?.users?.role;
  const parcels = useParcelsWithoutMemo(role);

  useEffect(() => {
    if (!canUseOrders(role)) history.replace("/dashboard");
  }, [history, role]);

  return (
    <div className="sp is-hub">
      <div className="sp-head">
        <button type="button" className="sp-link" onClick={() => history.push("/sales")}>‹ Sales</button>
        <span className="t13 grow">Same daily courier check as parcels on a memo.</span>
      </div>
      {!canUseParcels(role) ? (
        <p className="t13" role="status">Only the studio owner or a manager can track parcels.</p>
      ) : parcels.status === "loading" ? (
        <p className="t13" role="status">Loading parcels…</p>
      ) : parcels.status === "off" ? (
        <p className="t13" role="status">Parcels without a memo aren't switched on for your studio yet.</p>
      ) : (
        <ParcelsCard parcels={parcels} withoutMemo />
      )}
    </div>
  );
};

export default SalesParcelsPage;
